<template lang="">
  <div>
    <PositionGuid :posGuids="posGuids"></PositionGuid>
    <div class="article gWidth bg-white  padding" id="articlet" v-cloak>
      <div class="arts">
        <span class="right_tit" style="width:100%">留言详情</span>
        <p class="margin-top-lg text-center margin-bottom-lg title_p">
          {{ lydetails.title }}
        </p>
        <p
          class="text-center publish padding-bottom margin-bottom-lg text-sm text-gray"
        >
          发布：{{ lydetails.created_at }}
        </p>
        <p class="text-sm right_conts_p" v-html="lydetails.content"></p>
        <p class="margin-top-lg" v-if="lydetails.huifu">
          <span style="color: red;">回复：</span>
          <span>{{ lydetails.huifu }}</span>
        </p>
        <div class="replay_time">
          <span>回复时间：{{ lydetails.huifu_at }}</span>
          <span>回复单位：{{ lydetails.huifu_danwei }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { lydetail } from "@/api/gxq";
import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "LiuyanInfo",
  components: {
    PositionGuid,
  },
  data() {
    return {
      articleTitle: '保定国家高新技术产业开发区', // 初始标题
      contentSource: '保定国家高新技术产业开发区', // 初始内容来源
      posGuids: [
        {
          title: "公众留言",
          link: "/Gzly",
        },
        {
          title: "留言详情",
          link: "",
        },
      ],
      lydetails: {},
      id: this.$route.params.id,
    };
  },
  mounted() {
    this.wdetail();
  },
  methods: {
    async wdetail() {
      const { data } = await lydetail({ id: this.id });
      this.lydetails = data[0];
      // console.log(this.lydetails);
    },
  },
};
</script>
<style scoped="scoped">
.mores_span span:nth-child(7) {
  display: block;
}

.right_tit {
  width: 160px;
  height: 44px;
}

.diliver {
  width: 100%;
  height: 2px;
}

.left_tit {
  border: 1px solid #eae8e8;
  border-bottom: 2px solid rgba(1, 107, 213, 1);
  width: 270px;
  height: 46px;
  background-color: #fbfbfb;
}

.padding-lg {
  padding: 20px;
  padding-top: 0;
}

.title_p {
  font-weight: bold;
}

.replay_time {
  color: rgba(144, 144, 144, 1);
  font-size: 14px;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

@media screen and (min-width: 1200px) {
  .title_p {
    font-size: 34px;
    line-height: 58px;
  }

  .replay_time span:first-child {
    margin-right: 20px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1199px) {
  .title_p {
    font-size: 28px;
    line-height: 50px;
  }

  .replay_time span:first-child {
    margin-right: 16px;
  }
}

@media screen and (max-width: 768px) {
  .title_p {
    font-size: 18px;
    line-height: 38px;
  }

  .replay_time {
    flex-direction: column;
  }
}
</style>
